import InscricaoDesconto, { EnumTipoValor } from "@/Models/Domain/Viagem/Inscricao/InscricaoDesconto"
import { BooleanProps } from "@/utility-types"
import { Form, FormInstance, FormProps, Row, Col, Input } from "antd"
import { forwardRef } from "react";
import ViagemSelect from "../../ViagemSelect";
import InputPreco from "@/Components/Base/Input/InputPreco";
import AlunoDocumentoTipoSelect from "@/Components/Populados/Pessoa/Aluno/Documento/DocumentoTipo/AlunoDocumentoTipoSelect";
import { EnumDocumentoTipo } from "@/Models/Pessoa/Pessoa";
import DescontoTipoValorSelect from "./TipoValor/DescontoTipoValorSelect";
import AlunoSelect from "@/Components/Populados/Pessoa/Aluno/AlunoSelect";

export interface IInscricaoDescontoFormInstanceType {
    inscricaoDesconto:InscricaoDesconto;
}

export interface IInscricaoDescontoFormBasicRef extends FormInstance<IInscricaoDescontoFormInstanceType> {

}

export interface IInscricaoDescontoFormBasicProps extends FormProps<IInscricaoDescontoFormInstanceType> {
    codigo?:number,
    fieldsDisabled?:BooleanProps<IInscricaoDescontoFormInstanceType>
}

const InscricaoDescontoFormBasic = forwardRef<IInscricaoDescontoFormBasicRef, IInscricaoDescontoFormBasicProps>(function InscricaoDescontoFormBasic(
    {
        codigo,
        form : formParam,
        component,
        layout,
        autoComplete,
        fieldsDisabled,
        disabled,
        ...props
    },
    ref
){
    const isAlteracao = codigo !== undefined && codigo !== null && !isNaN(codigo) && codigo > 0;
    const [newForm] = Form.useForm<IInscricaoDescontoFormInstanceType>();
    const form = formParam ?? newForm;

    const codPessoaAluno = Form.useWatch(["inscricaoDesconto", "codPessoaAluno"], form);
    const codDocumentoTipo = Form.useWatch(["inscricaoDesconto", "codDocumentoTipo"], form);
    const codTipoValor = Form.useWatch(["inscricaoDesconto", "codTipoValor"], form);

    return <Form<IInscricaoDescontoFormInstanceType>
        {...props}
        ref={ref}
        form={form}
        component={component ?? "div"}
        layout={layout ?? "vertical"}
        autoComplete={autoComplete ?? "off"}
        disabled={disabled}
    >
        <Row gutter={8} wrap>
            <Form.Item<IInscricaoDescontoFormInstanceType> name={["inscricaoDesconto", "codigo"]} hidden></Form.Item>

            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
                <Form.Item<IInscricaoDescontoFormInstanceType> 
                    name={["inscricaoDesconto", "codViagem"]}
                    label="Viagem"
                    rules={[ { required : true } ]}
                >
                    <ViagemSelect 
                        disabled={isAlteracao ? true : fieldsDisabled?.inscricaoDesconto?.codViagem ?? undefined} 
                    />
                </Form.Item>
            </Col>
            
            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
                <Form.Item<IInscricaoDescontoFormInstanceType> 
                    name={["inscricaoDesconto", "codPessoaAluno"]}
                    label="Aluno"
                    rules={[ { required : false } ]}
                >
                    <AlunoSelect 
                        keySelector="codPessoa"
                        disabled={isAlteracao ? true : fieldsDisabled?.inscricaoDesconto?.codPessoaAluno ?? undefined}
                        placeholder="Não cadastrado"
                        allowClear
                    />
                </Form.Item>
            </Col>

            {
                // Aluno não cadastro
                (codPessoaAluno === undefined || codPessoaAluno === null || codPessoaAluno <= 0) && <>
                    <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
                        <Form.Item<IInscricaoDescontoFormInstanceType> 
                            name={["inscricaoDesconto", "codDocumentoTipo"]}
                            label="Tipo documento"
                            rules={[ { required : true } ]}
                        >
                            <AlunoDocumentoTipoSelect 
                                disabled={isAlteracao ? true : fieldsDisabled?.inscricaoDesconto?.codDocumentoTipo ?? undefined} 
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
                        <Form.Item<IInscricaoDescontoFormInstanceType> 
                            name={["inscricaoDesconto", "documento"]}
                            label="Documento"
                            rules={[ 
                                { required : true },
                                codDocumentoTipo === EnumDocumentoTipo.CPF ? { pattern: /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/, message: "Por favor, insira um CPF válido!" } : undefined
                            ].filter(f => f !== undefined)}
                        >
                            <Input 
                                disabled={isAlteracao ? true : fieldsDisabled?.inscricaoDesconto?.documento ?? undefined} 
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
                        <Form.Item<IInscricaoDescontoFormInstanceType> 
                            name={["inscricaoDesconto", "nomePessoaAluno"]}
                            label="Nome aluno"
                            rules={[ 
                                { required : true },
                            ]}
                        >
                            <Input
                                disabled={isAlteracao ? true : fieldsDisabled?.inscricaoDesconto?.nomePessoaAluno ?? undefined} 
                            />
                        </Form.Item>
                    </Col>
                </>
            }

            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
                <Form.Item<IInscricaoDescontoFormInstanceType> 
                    name={["inscricaoDesconto", "codTipoValor"]}
                    label="Tipo valor"
                    rules={[ { required : true } ]}
                >
                    <DescontoTipoValorSelect 
                        disabled={fieldsDisabled?.inscricaoDesconto?.codTipoValor ?? undefined} 
                    />
                </Form.Item>
            </Col>
            
            <Col xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
                <Form.Item<IInscricaoDescontoFormInstanceType> 
                    name={["inscricaoDesconto", "valor"]}
                    label="Valor"
                    rules={[ { required : true } ]}
                >
                    <InputPreco
                        placeholder={codTipoValor === EnumTipoValor.PercValor ? "Percentual" : "Valor"}
                        addonBefore={codTipoValor === EnumTipoValor.PercValor ? "%" : "R$"}
                        min={0.01} 
                        max={codTipoValor === EnumTipoValor.PercValor ? 100.00 : undefined}
                        precision={2} 
                        controls={false}
                    />
                </Form.Item>
            </Col>
        </Row>
    </Form>
});

export default InscricaoDescontoFormBasic;